
import { AtCoreServiceClient } from '@api/AtCoreServiceClient'
import {
    clearCredentialPromiseForRole,
    IAwsCredentials,
    setCredentialPromiseForRole,
} from '@atredux/slices/userRoleSlice'
import { getRoleCredentialPromise } from '@atredux/selectors/userRoleSelector'
import { store } from '@atredux/store'

export const UserRole = Object.freeze({
    VOICE_USER_ROLE: 'VOICE_USER_ROLE',
})

export const assumeUserRole = (storeId: string, role: string, bypassCache?: boolean): Promise<IAwsCredentials> => {
    return getAssumeUserRolePromise(storeId, role, bypassCache)
        .then((credentials) => {
            // Return cloned copy
            return Object.assign({}, credentials)
        })
}

const getAssumeUserRolePromise = (storeId: string, role: string, bypassCache?: boolean): Promise<IAwsCredentials> => {
    if (!bypassCache) {
        const cachedPromise = getRoleCredentialPromise(store.getState(), role)
        if (cachedPromise && cachedPromise instanceof Promise) {
            return cachedPromise
        } else {
            console.log('ATBase: Assume role credentials promise not found in local storage, retrieving from service.')
        }
    }
    const clientPromise: Promise<IAwsCredentials> = AtCoreServiceClient.getInstance().assumeUserRole(storeId, role)
        .then((response) => {
            if (!response.ok) {
                return Promise.reject(`An error occurred while attempting to assume role in store ${storeId} with role ${role}`)
            }
            return response.body
        })
        .catch((error) => {
            console.log('ATBase: Got error when calling assumeUserRole: ', error)
            // Clear the promise cache for role so that next time call is retried
            store.dispatch(clearCredentialPromiseForRole({ role }))
            return Promise.reject(error)
        })
    store.dispatch(setCredentialPromiseForRole({
        role,
        promise: clientPromise,
    }))
    return clientPromise
}
